import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ValmislauseAdmin from "../components/ValmislauseAdmin";

// Standalone top-level page for the Valmislauseet admin view — previously
// a tab inside AllReports.jsx (/raportit?tab=valmislauseet), moved to its
// own sidebar entry/route since it isn't really "about reports", it's its
// own library the report editor's "+ Valmislause" modal pulls from.
//
// View state (which "Raporttityyppi" tab, which chapter, and which tag are
// open) is kept in both the URL and localStorage, same dual pattern
// AllReports.jsx used for these same three fields — a shared link lands on
// that exact view, and plain navigation back to the page with no query
// string still remembers last time. localStorage keys are unchanged from
// the old tab (valmislause-type/-tag/-chapter), so a link saved before
// this move still resolves the same remembered state.
export default function Valmislauseet() {
  const navigate = useNavigate();
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const [valmislauseType, setValmislauseType] = useState(() => {
    const saved = localStorage.getItem("valmislause-type");
    return saved !== null ? saved : (query.get("vtype") || "ALL");
  });
  const [valmislauseTag, setValmislauseTag] = useState(() => {
    const saved = localStorage.getItem("valmislause-tag");
    return saved !== null ? saved : (query.get("vtag") || "");
  });
  const [valmislauseChapter, setValmislauseChapter] = useState(() => {
    const saved = localStorage.getItem("valmislause-chapter");
    return saved !== null ? saved : (query.get("vchapter") || "");
  });

  useEffect(() => {
    const params = new URLSearchParams();
    if (valmislauseType && valmislauseType !== "ALL") params.set("vtype", valmislauseType);
    if (valmislauseTag) params.set("vtag", valmislauseTag);
    if (valmislauseChapter) params.set("vchapter", valmislauseChapter);
    navigate(`?${params.toString()}`, { replace: true });
  }, [valmislauseType, valmislauseTag, valmislauseChapter]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    localStorage.setItem("valmislause-type", valmislauseType || "ALL");
    // valmislauseTag/valmislauseChapter can become a real `null` (e.g. the
    // open tag got deleted) — localStorage.setItem coerces that to the
    // literal string "null", which getItem would then read back as a
    // truthy value on the next visit.
    localStorage.setItem("valmislause-tag", valmislauseTag || "");
    localStorage.setItem("valmislause-chapter", valmislauseChapter || "");
  }, [valmislauseType, valmislauseTag, valmislauseChapter]);

  return (
    <div className="main-content">
      <div className="bg-success text-white text-center py-4 shadow-sm">
        <h1 className="fw-bold fs-4 display-5 mb-1">Valmislauseet</h1>
        <p className="opacity-75 mb-0">Hallitse raporttien valmislauseita ja niiden tageja</p>
      </div>

      <div className="container py-4">
        <div className="border rounded overflow-hidden">
          <ValmislauseAdmin
            typeFilter={valmislauseType}
            onTypeFilterChange={setValmislauseType}
            selectedTag={valmislauseTag}
            onSelectedTagChange={setValmislauseTag}
            activeChapter={valmislauseChapter}
            onActiveChapterChange={setValmislauseChapter}
          />
        </div>
      </div>
    </div>
  );
}
